import React from 'react';
import { LeftOutlined } from '@ant-design/icons';
import { Button } from 'antd-mobile';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LocaleSwitcher } from '../../../components/LocaleSwitcher';
import { downloadDetailPageStyles } from './styles';
import { useDownloadDefaultLocale } from '../useDownloadDefaultLocale';

const STEP_KEYS = ['download', 'install', 'permission', 'use'] as const;

export const DownloadDetailPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('download');
  useDownloadDefaultLocale();

  return (
    <main style={downloadDetailPageStyles.page}>
      <div style={downloadDetailPageStyles.shell}>
        <div style={downloadDetailPageStyles.navRow}>
          <button
            type="button"
            aria-label={t('detail.backAriaLabel')}
            style={downloadDetailPageStyles.backButton}
            onClick={() => navigate('/download')}
          >
            <LeftOutlined />
          </button>
          <LocaleSwitcher
            tone="light"
            labelMode="short"
            style={downloadDetailPageStyles.localeSwitcher}
          />
        </div>

        <div style={downloadDetailPageStyles.eyebrow}>{t('detail.eyebrow')}</div>
        <h1 style={downloadDetailPageStyles.title}>{t('detail.title')}</h1>
        <div style={downloadDetailPageStyles.intro}>{t('detail.intro')}</div>

        {STEP_KEYS.map((key, index) => (
          <section key={key} style={downloadDetailPageStyles.section}>
            <div style={downloadDetailPageStyles.sectionHeader}>
              <div style={downloadDetailPageStyles.stepIndex}>{index + 1}</div>
              <div style={downloadDetailPageStyles.sectionTitle}>{t(`detail.steps.${key}.title`)}</div>
            </div>
            <div style={downloadDetailPageStyles.sectionBody}>
              <div>{t(`detail.steps.${key}.body`)}</div>
              <ul style={downloadDetailPageStyles.list}>
                {(t(`detail.steps.${key}.items`, { returnObjects: true }) as string[]).map((item) => (
                  <li key={item} style={downloadDetailPageStyles.listItem}>{item}</li>
                ))}
              </ul>
            </div>
          </section>
        ))}

        <Button block color="warning" style={downloadDetailPageStyles.cta} onClick={() => navigate('/download')}>
          {t('detail.downloadCta')}
        </Button>
      </div>
    </main>
  );
};
